import { useSyncExternalStore } from "react";
import {
  DEFAULT_RAZA_PRINT_PAPER_SIZE,
  readStoredRazaPrintPaperSize,
  subscribeTenantBrandingUpdated,
  type RazaPrintPaperSize,
} from "@/utils/tenant-branding-cache";

/**
 * Raza hardcopy paper size from authenticated branding cache (`GET /tenant-branding/me`).
 * Defaults to A4 until branding is loaded.
 */
export function useRazaPrintPaperSize(): RazaPrintPaperSize {
  return useSyncExternalStore(
    subscribeTenantBrandingUpdated,
    readStoredRazaPrintPaperSize,
    () => DEFAULT_RAZA_PRINT_PAPER_SIZE
  );
}
